export default __webpack_public_path__ + "cbfd6d0150e11aa27d80b3d7e7111eea.svg";